module.exports = __webpack_public_path__ + "83aab0cd7612d00c464605978a0ea6c5.pdf";